/* eslint-disable no-param-reassign */
import angular from 'angular';
import template from './plan-upload.jade';
import uiCianIcon from '@cian/ui/app/components/icon/index.jsm';
import uiCianPreloader from '@cian/ui/app/components/preloader/index.jsm';

import './plan-upload.styl';

export default angular
  .module('ui.cian.planUpload', [uiCianIcon, uiCianPreloader, 'ui.cian.photoTransfer'])

  .directive('cianUiPlanUpload', [
    'PhotoTransfer',
    PhotoTransfer => ({
      scope: {},
      bindToController: {
        url: '=',
        model: '=ngModel',
        cuiInvalid: '=?',
        cuiRequired: '=?',
      },
      require: ['ngModel', 'cianUiPlanUpload'],
      link(scope, el, attr, ctrls) {
        ctrls[1].init(ctrls[0]);
      },
      controller: [
        '$rootScope',
        '$timeout',
        'config',
        'popupService',
        'planService',
        // eslint-disable-next-line func-names
        function ($rootScope, $timeout, config, popupService, planService) {
          const apiBaseUrl = config.get('addformConfig.baseApiUrl');
          const serverError = 'server';
          const layoutUploadEvent = 'layoutUpload';
          const layoutRemoveEvent = 'layoutRemove';
          const uploadUrl = '/addform/v2/images/';

          this.init = ngModel => {
            this.isLoading = false;

            if (this.model && this.model.id) {
              this.file = {
                id: this.model.id,
                name: 'план',
                isDefault: this.model.isDefault,
              };
              // Фото планировки появляется раньше чем компонент со всеми фото, поэтому при редактировании
              // фото не попадает в общий комопнент, т.к слушатель события для него ещё не появился
              $timeout(() => {
                $rootScope.$emit(layoutUploadEvent, this.file);
                planService.registerPhotoIdAsPlan(this.model.id);
              });
            }

            // наличие id означает что метод вызван извне
            this.remove = id => {
              if (!id && this.file && this.file.id) {
                this.warning = null;
                $rootScope.$emit(layoutRemoveEvent, { id: this.file.id });
              }

              this.setModel(null);
            };

            this.onSelect = file => {
              ngModel.$setTouched();

              if (!file || file.$error) {
                this.setError(file);

                return;
              }

              if (!this.isImageResolutionValid(file.$ngfWidth, file.$ngfHeight)) {
                file.$warning = 'badWH';
                this.setError(file, true);
              }

              const fileUpload = PhotoTransfer.upload(file, this.url);
              this.isLoading = true;

              fileUpload.then(
                response => {
                  if (!response || !response.data || !response.data.id) {
                    file.$error = serverError;
                    this.setError(file);
                  } else {
                    this.setModel(file, response.data.id);
                  }
                },
                () => {
                  file.$error = serverError;
                  this.setError(file);
                },
              );
            };

            this.setModel = (file, id) => {
              const model = file ? { id } : null;

              if (file) {
                file.id = id;
                $rootScope.$emit(layoutUploadEvent, file);
                planService.registerPhotoIdAsPlan(id);
              }

              this.error = null;
              this.isLoading = false;
              this.file = file;
              this.model = model;
              ngModel.$modelValue = model;
              ngModel.$setViewValue(model);
              ngModel.$validate();
            };

            this.setError = (file, isWarning) => {
              this.isLoading = false;

              if (!file) {
                this.error = '';

                return;
              }

              const errorMessage = {
                minWidth: 'Ширина изображения меньше 800px',
                minHeight: 'Высота изображения меньше 800px',
                pattern: 'Файл не является изображением',
                maxSize: 'Размер файла превышает 10 МБ',
                badWH: 'Рекомендуемое разрешение больше 800х600',
                server: 'Не удалось загрузить файл',
              };

              if (isWarning) {
                this.warning = errorMessage[file.$warning];
              } else {
                this.error = errorMessage[file.$error];
              }
            };

            this.getImagePreviewUrl = () => {
              return `${apiBaseUrl}${uploadUrl}${this.model.id}/`;
            };

            this.openFullscreen = () => {
              popupService.openPopup('fullscreenPlanPreview', {
                options: {
                  imageUrl: this.getImagePreviewUrl(),
                },
              });
            };

            this.isImageResolutionValid = (width, height) => {
              const isMoreThanMinimalResolution = height > 200 && width > 200;
              const isLessThanRecommendedResolution =
                (height >= 600 && width >= 800) || (height >= 800 && width >= 600);

              return !isMoreThanMinimalResolution || isLessThanRecommendedResolution;
            };

            this.isPlanIdExists = () => {
              return this.model && Boolean(this.model.id);
            };

            this.isUploaderVisible = () => {
              return !this.isPlanIdExists() && !this.isLoading;
            };

            this.isUploaderDisabled = () => {
              return this.isLoading || this.isPlanIdExists();
            };

            this.isLoaderVisible = () => {
              return this.isLoading;
            };

            this.isPreviewVisible = () => {
              return this.isPlanIdExists() && !this.isLoading;
            };

            this.isErrorVisible = () => {
              return !this.isLoaderVisible() && (this.error || this.warning);
            };

            this.isDescriptionHintVisible = () => {
              return !this.error && !this.warning;
            };

            this.layoutRemoveEventHandler = $rootScope.$on(layoutRemoveEvent, (event, { id }) => {
              this.remove(id);
            });
          };
        },
      ],
      replace: true,
      controllerAs: 'planUpload',
      template,
    }),
  ]).name;
